import { render } from "./editcategory.vue?vue&type=template&id=22185d13"
import script from "./editcategory.vue?vue&type=script&lang=js"
export * from "./editcategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__